import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsAccordionBlockItemEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsAccordionBlockItemEntity
